import styled from 'react-emotion'
import PropTypes from 'prop-types'

import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'
import CloseIcon from 'components/App/DesktopView/shared/Composer/CloseIcon'

import { Flex } from 'shared/ui'
import RecipientsEditor from './RecipientsEditor'
import withEditMode from './withEditMode'
import Label from './Label'
import Row from './Row'
import PinIcon from './PinIcon'

const ToRow = ({
  bccVisible,
  ccVisible,
  children, // e.g. FormSwitcherButton
  className,
  closeTo,
  editing,
  fromVisible,
  onActionClick,
  subjectVisible,
  ticketId,
  ...rest
}) => {
  return (
    <Row first className={className}>
      {children}
      <Flex
        alignItems="baseline"
        className="toEditor"
        flex="1 1 60%"
        ml={children ? 2 : 0}
        css={`
          min-width: 0;
        `}
      >
        <Label>To:</Label>
        <RecipientsEditor
          key={`recipientseditor-to-${ticketId}`}
          ml={1}
          type="to"
          ticketId={ticketId}
          {...rest}
        />
      </Flex>
      <Flex
        className="actions"
        alignSelf="flex-end"
        mr={closeTo ? 3 : undefined}
      >
        <Actions
          hideBcc={bccVisible}
          hideCc={ccVisible}
          hideFrom={fromVisible}
          hideSubject={subjectVisible}
          onClick={onActionClick}
        />
      </Flex>
      <PinIcon />
      {closeTo && <CloseIcon to={closeTo} />}
    </Row>
  )
}

ToRow.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  closeTo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  recipientsOpenUpward: PropTypes.bool,
}

ToRow.defaultProps = {
  closeTo: undefined,
  recipientsOpenUpward: false,
}

export default styled(withEditMode(ToRow))`
  . label {
    line-height: 24px; /* hacks around jumpy label as you remove recipient */
  }

  .actions {
    line-height: 2.67;
  }
`
